import { useEffect, useState } from "react";

const BREAKPOINTS = { sm: 576, lg: 992 };

export const useWindowWidth = () => {
    const [screenSizes, setScreenSizes] = useState({ isSmall: false, isLarge: false });
  
    useEffect(() => {
      const smallMQL = window.matchMedia(`(max-width: ${BREAKPOINTS.sm}px)`);
      const largeMQL = window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`);
  
      const updateScreenSizes = () => {
        setScreenSizes({
          isSmall: smallMQL.matches,
          isLarge: largeMQL.matches
        });
      };
  
      updateScreenSizes();
      smallMQL.addEventListener('change', updateScreenSizes);
      largeMQL.addEventListener('change', updateScreenSizes);
  
      return () => {
        smallMQL.removeEventListener('change', updateScreenSizes);
        largeMQL.removeEventListener('change', updateScreenSizes);
      };
    }, [BREAKPOINTS.sm, BREAKPOINTS.lg]);
  
    return screenSizes;
  };